/******/ (() => {
window.PXUTheme.jsCart = {
  init: function ($section) {
    this.$section = $section;
    $(document).off('click.jcsCartPage', '[data-cart-page-delete]')
      .on('click.jcsCartPage', '[data-cart-page-delete]', function (event) {
        event.preventDefault();
        window.PXUTheme.jsCart.removeFromCart($(this).attr('data-line-item-key'));
      });
    // Delegate because the native cart form can be refreshed after adding an item.
    $(document).off('keydown.jcsCartPage', '#cart_form')
      .on('keydown.jcsCartPage', '#cart_form', function (event) {
        if (event.keyCode === 13 && event.target.matches('input')) event.preventDefault();
      });
  },
  removeFromCart: function (lineID) {
    const row = this.$section.find('[data-line-item]').filter(function () {
      return $(this).attr('data-line-item') === String(lineID);
    });
    window.PXUTheme.jsAjaxCart.removeFromCart(lineID, row.attr('data-cart-item'));
  },
  captureFocus: function () {
    const element = document.activeElement;
    const row = element.closest('[data-cart-item]');
    if (!row || !this.$section[0]?.contains(element)) return null;
    return { element, key: row.dataset.cartItem,
      index: this.$section.find('[data-cart-item]').index(row),
      selector: element.matches('[data-update-quantity]') ? '[data-update-quantity="' + element.dataset.updateQuantity + '"]' :
        element.matches('.quantity-input') ? '.quantity-input' : '[data-cart-page-delete]' };
  },
  restoreFocus: function (saved) {
    if (!saved || saved.element.isConnected) return;
    const rows = this.$section.find('[data-cart-item]').toArray();
    const same = rows.find(row => row.dataset.cartItem === saved.key);
    const row = same || rows[Math.min(saved.index, rows.length - 1)];
    let target = (same && same.querySelector(saved.selector)) || row?.querySelector('[data-cart-page-delete]') ||
      this.$section.find('.cart__empty-cart-message a')[0];
    if (target?.disabled) target = row?.querySelector('.quantity-input');
    if (target?.getClientRects().length) target.focus({ preventScroll: true });
  },
  updateView: function (cart, lineID) {
    const section = this.$section;
    if (!section?.length) return;
    const requestId = this.viewRequestId = (this.viewRequestId || 0) + 1;
    if (cart.item_count > 0) {
      $.ajax({
        dataType: 'html', cache: false,
        url: window.PXUTheme.routes.cart_url || '/cart',
        success: html => {
          if (requestId !== this.viewRequestId) return;
          // Capture at replacement time; a response must not reclaim focus the user moved.
          const saved = this.captureFocus();
          const updated = $(html);
          const list = updated.find('.cart__item-list');
          if (!list.length) { this.showRefreshError(); return; }
          // Preserve the inventory warning produced by the quantity request.
          if (lineID != null) {
            const current = section.find('[data-line-item]').filter(function () {
              return $(this).attr('data-line-item') === String(lineID);
            });
            const key = current.attr('data-cart-item');
            const warning = current.find('.quantity-warning').text();
            if (warning) list.find('[data-cart-item]').filter(function () {
              return $(this).attr('data-cart-item') === key;
            }).find('.quantity-warning').text(warning);
          }
          // Replace rows only: the list also contains the subtotal, gift note and checkout controls.
          // Keeping those controls preserves unsaved input and focus outside the changed rows.
          const currentList = section.find('.cart__item-list');
          currentList.find('.cart__card').remove();
          currentList.prepend(list.find('.cart__card'));
          section.find('.cart__subtotal-container').replaceWith(updated.find('.cart__subtotal-container'));
          for (const selector of ['.cart__discounts', '.cart__total-savings']) {
            const next = updated.find(selector);
            const current = section.find(selector);
            if (current.length) current.replaceWith(next);
            else if (next.length) section.find('.cart__subtotal-container')[selector === '.cart__discounts' ? 'before' : 'after'](next);
          }
          section.find('.cart__empty-cart-message').addClass('is-hidden');
          section.find('.cart__form').removeClass('is-hidden');
          section.find('#cart_form').removeClass('visually-hidden');
          $('[data-bind="itemCount"]').text(cart.item_count);
          if (window.PXUTheme.currencyConverter) window.PXUTheme.currencyConverter.convertCurrencies();
          this.restoreFocus(saved);
        },
        error: () => { if (requestId === this.viewRequestId) this.showRefreshError(); }
      });
    } else {
      const saved = this.captureFocus();
      section.find('.cart__item-list').empty();
      section.find('.cart__empty-cart-message').removeClass('is-hidden');
      section.find('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
      this.restoreFocus(saved);
    }
  },
  showRefreshError: function () {
    this.$section.find('[data-cart-removal-error]').text(window.PXUTheme.jsAjaxCart?.refresh_error ||
      'Your cart changed, but the display could not refresh. Please reload this page before continuing.');
  },
  unload: function () {
    $(document).off('.jcsCartPage');
  }
};
/******/ })();
